import { GET_MONTHLY_RECORDS } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_MONTHLY_RECORDS:
            return action.payload;
        default:
            return state;
    }
}